import en from './en.json'
import zh from './zh.json'
import ar from './ar.json'
import ja from './ja.json'
import fr from './fr.json'
import ru from './ru.json'
import hk from './hk.json'
import pl from './pl.json'
export default {
  en,
  zh,
  ar,
  ja,
  fr,
  ru,
  hk,
  pl
}